import { c as _c } from "react/compiler-runtime";
import { Label } from "@repo/ui/components/ui/label";
import { PlacePicker } from "@/lib/components/PlacePicker";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlacePickerField(t0) {
  const $ = _c(9);
  const {
    editor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(Label, {
      children: "Kopplad plats"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = editor.form.placeId ?? null;
  let t3;
  if ($[1] !== editor) {
    t3 = id => editor.updateField("placeId", id);
    $[1] = editor;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = /*#__PURE__*/_jsx(PlacePicker, {
      value: t2,
      onChange: t3
    });
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx("p", {
      className: "text-xs text-gray-500",
      children: "Koppla upplevelsen till en fysisk plats f\xF6r att visa den p\xE5 kartan"
    });
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t1, t4, t5]
    });
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}